/* eslint-disable default-case */
/* eslint-disable prefer-destructuring */
/* eslint-disable vars-on-top */
/* eslint-disable no-var */
/* eslint-disable no-undef */
/* eslint-disable */ 
/* Copyright (c) Librestream Technologies. All rights reserved. */
import { TelestrationManager, TelePointConstants, argbToRGB, TelePointDataV3 } from '../lsexif/telestration';

import {LS_DATASTREAM_PARTICIPANTID} from '../../utils/constants/DatastreamConstant';
import { CALL_DASHBOARD } from 'UTILS/constants/DOMElementConstants';
import {
  DEFAULT_TEXT_INPUT_SIZE,
  CANVAS_TELE_FONT_SIZE_RESOLUTION,
  DEFAULT_FONT_SIZE,
} from 'UTILS/constants/TelestrationConstant';
import isEmpty from 'lodash/isEmpty';

var CANVAS_LOG_TAG = 'CANVAS';
var CANVAS_LOG_EN = false;

var CANVAS_LINE_WIDTH_FACTOR = 200;
var CANVAS_ARRLOWLINE_HEAD_BOX_SIZE = 45;
var CANVAS_TELE_FONT_SIZE = 12;

export function CanvasManager(telestrationCanvas,isImage) {
  
  this.canvas = telestrationCanvas; 
  this.context = this.canvas.getContext('2d');
  this.canvasOffset = this.canvas.getBoundingClientRect();
  this.context.lineJoin = 'round';
  this.preservedOffSetTop = 0;

  this.tm = new TelestrationManager();
  

  this.scaleX = 1;
  this.scaleY = 1;

  this.image = null;
  this.imageExif = null;
  // this.imageShareMode = STILL_IMAGE_CONSTANTS.StillImageShareModeExit.id;

  

  var cm = this;

  CanvasManager.prototype.calculateFontSize =  (config) => {
    const textScale = (config.height / CANVAS_TELE_FONT_SIZE_RESOLUTION);
    const scaledFontSize = (textScale * DEFAULT_FONT_SIZE);
    console.debug(`Font calculated : ${scaledFontSize} height used for scaling : ${config.height}`);
    return scaledFontSize;
  }
  CanvasManager.prototype.getScaleAndOffset = function (isSelfVideo, videoConfig, isVideoTeleOnImage) {
    let videoElement = null;
    let scaleX, scaleY, offSetX, offSetY;
    let selectedVideoConfigWidth, selectedVideoConfigHeight;
    this.canvasOffset = this.canvas.getBoundingClientRect();
    if (isImage) {
      videoElement = document.getElementById(CALL_DASHBOARD.PHOTO_ID);
      selectedVideoConfigWidth = isVideoTeleOnImage ? videoConfig.width : videoElement.naturalWidth;
      selectedVideoConfigHeight = isVideoTeleOnImage ? videoConfig.height :videoElement.naturalHeight;
    } else {
      if (isSelfVideo) {
        videoElement = document.getElementById(CALL_DASHBOARD.SELF_VIDEO_ID);
      } else {
        videoElement = document.getElementById(CALL_DASHBOARD.REMOTE_VIDEO_ID);
      }
      selectedVideoConfigWidth = videoElement.videoWidth;
      selectedVideoConfigHeight = videoElement.videoHeight;
      if (isSelfVideo && videoConfig?.width && videoConfig?.height) {
        selectedVideoConfigWidth = videoConfig.width;
        selectedVideoConfigHeight = videoConfig.height;
      }
    }
    scaleX = this.canvas.width / selectedVideoConfigWidth;
    scaleY = this.canvas.height / selectedVideoConfigHeight;
    offSetX = this.canvasOffset.left;
    offSetY = this.canvasOffset.top;
    console.debug(`Telestration scaleX : ${scaleX}, scaleY : ${scaleY}, offsetX : ${offSetX}, offsetY : ${offSetY}`);

    return { scaleX, scaleY, offSetX, offSetY}
  
  };

  CanvasManager.prototype.reverseScale = function(isSelfVideo, smoothed,  config, isTextTelestration=false) {
    let startPointX = 0, startPointY = 0, endPointX = 0, endPointY = 0; 
    let scaleX = 1, scaleY = 1, offSetX=0, offSetY=0;
    
    const scaleAndOffset = this.getScaleAndOffset(isSelfVideo,  config);
    
    offSetX = scaleAndOffset.offSetX;
    offSetY = scaleAndOffset.offSetY;
    scaleX = scaleAndOffset.scaleX;
    scaleY = scaleAndOffset.scaleY;

    if(isTextTelestration)
    {
      offSetY = this.preservedOffSetTop;
      
    }
    
    startPointX = smoothed[0]?.x - offSetX;
    startPointY = smoothed[0]?.y - offSetY;
    endPointX = smoothed[1]?.x - offSetX;
    endPointY = smoothed[1]?.y - offSetY;
    
   
    scaleX = 1/scaleX;
    scaleY = 1/scaleY;
    startPointX = startPointX * scaleX;
    startPointY = startPointY * scaleY;
    endPointX = endPointX * scaleX;
    endPointY = endPointY * scaleY;
      
    
    return {startPointX, startPointY, endPointX, endPointY, scaleX, scaleY};
  };

  CanvasManager.prototype.calculateScale = function(isSelfVideo, smoothed,  isLocalTelestration, config, isVideoTeleOnImage, isTextTelestration=false) {
    let startPointX = 0, startPointY = 0, endPointX = 0, endPointY = 0; 
    let scaleX = 1, scaleY = 1, offSetX = 0, offSetY = 0;
  
    const scaleAndOffset = this.getScaleAndOffset(isSelfVideo, config, isVideoTeleOnImage);
  
    offSetX = scaleAndOffset.offSetX;
    offSetY = scaleAndOffset.offSetY;
    scaleX = scaleAndOffset.scaleX;
    scaleY = scaleAndOffset.scaleY;
  
    if(!isLocalTelestration) {
      startPointX = smoothed[0]?.x * scaleX;
      startPointY = smoothed[0]?.y * scaleY;
      endPointX = smoothed[1]?.x * scaleX;
      endPointY = smoothed[1]?.y * scaleY;
      
    } else {
      if(isTextTelestration)
      {
        offSetY =  this.preservedOffSetTop;
      }
      startPointX = smoothed[0]?.x - offSetX;
      startPointY = smoothed[0]?.y - offSetY;
      endPointX = smoothed[1]?.x - offSetX;
      endPointY = smoothed[1]?.y - offSetY;
    }
    console.debug(`Received coordinates for ${isLocalTelestration? 'Local ': 'Remote'} Telestration- START X:${smoothed[0]?.x}, Y:${smoothed[0]?.y} END X: ${smoothed[1]?.x}  Y:${smoothed[1]?.y}`);
    console.debug(`Scaled coordinates for ${isLocalTelestration? 'Local ': 'Remote'} Telestration- START X:${startPointX}, Y:${startPointY} END X: ${endPointX}  Y:${endPointY}`);
    return {startPointX, startPointY, endPointX, endPointY, scaleX, scaleY, offSetX, offSetY};
  };


  CanvasManager.prototype.getScaleDifference = function (isSelfVideo, videoConfig, imageRes, _coords, isScreenShare = false) {
    let videoElement = null;
    let scaleX, scaleY, imageWidthFactor = 0, imageHeightFactor = 0;
    let selectedVideoConfigWidth, selectedVideoConfigHeight;
    if (isSelfVideo) {
      videoElement = document.getElementById(CALL_DASHBOARD.SELF_VIDEO_ID);
    } else {
      videoElement = document.getElementById(CALL_DASHBOARD.REMOTE_VIDEO_ID);
    }
    selectedVideoConfigWidth = videoElement.videoWidth;
    selectedVideoConfigHeight = videoElement.videoHeight;
    if (isSelfVideo && videoConfig?.width && videoConfig?.height) {
      selectedVideoConfigWidth = videoConfig.width;
      selectedVideoConfigHeight = videoConfig.height;
    }
    scaleX = imageRes.width / selectedVideoConfigWidth;
    scaleY = imageRes.height / selectedVideoConfigHeight;
    const scaleFactor = Math.min(scaleX, scaleY);
    const scaledVideoConfig = {
      width: selectedVideoConfigWidth * scaleFactor,
      height: selectedVideoConfigHeight * scaleFactor,
    };
    if (scaleFactor === scaleY) {
      imageWidthFactor = (imageRes.width - scaledVideoConfig.width) / 2;
    } else if (scaleFactor === scaleX) {
      imageHeightFactor = (imageRes.height - scaledVideoConfig.height) / 2;
    }
    console.debug('Get scale difference:: scaleX', scaleX, 'scaleY', scaleY, 'scaledVideoConfig', scaledVideoConfig, 'imageWidthFactor',imageWidthFactor, ' imageHeightFactor', imageHeightFactor, imageRes);
    const scaledCoords = _coords.map((coord) => ({
      x: Math.round((coord.x * scaleFactor ) + imageWidthFactor),
      y: Math.round((coord.y * scaleFactor) + imageHeightFactor),
    }));
    return scaledCoords;
  }


CanvasManager.vectorDot = function (p1, p2) {
  return p1.x * p2.x + p1.y * p2.y;
};

CanvasManager.vectorLengthSquared = function (p1) {
  return CanvasManager.vectorDot(p1, p1);
};

CanvasManager.simplifyDP = function (points, j, k, marked, tolerance) {
  if (k <= j + 1)
  // there is nothing to decimate
  { return; }

  // check for adequate approximation by segment S from v[j] to v[k]
  var maxi = j; // index of vertex farthest from S
  var maxd2 = 0; // distance squared of farthest vertex
  var tol2 = tolerance * tolerance; // tolerance squared
  var u = { x: points[k].x - points[j].x, y: points[k].y - points[j].y }; // segment direction vector
  var cu = CanvasManager.vectorLengthSquared(u); // segment length squared

  // test each vertex v[i] for max distance from S
  // compute using the Algorithm dist_Point_to_Segment()
  // Note: this works in any dimension (2D, 3D, ...)
  var w; var
    Pb;
  var b; var cw; var
    dv2; // dv2 = distance v[i] to S squared

  for (var i = j + 1; i < k; i++) {
    // compute distance squared
    w = { x: points[i].x - points[j].x, y: points[i].y - points[j].y };
    cw = CanvasManager.vectorDot(w, u);
    if (cw <= 0) dv2 = CanvasManager.vectorLengthSquared({ x: points[i].x - points[j].x, y: points[i].y - points[j].y });
    else if (cu <= cw) dv2 = CanvasManager.vectorLengthSquared({ x: points[i].x - points[k].x, y: points[i].y - points[k].y });
    else {
      b = cw / cu;
      u = { x: u.x * b, y: u.y * b };
      Pb = { x: points[j].x + u.x, y: points[j].y + u.y };
      dv2 = CanvasManager.vectorLengthSquared({ x: points[i].x - Pb.x, y: points[i].y - Pb.y });
    }
    // test with current max distance  squared
    if (dv2 <= maxd2) continue;
    // v[i] is a new max vertex
    maxi = i;
    maxd2 = dv2;
  }
  if (maxd2 > tol2) {
    // error is worse than the tolerance
    // split the polyline at the farthest  vertex from S
    marked[maxi] = true; // mark v[maxi] for the reduced polyline
    // recursively decimate the two subpolylines at v[maxi]
    CanvasManager.simplifyDP(points, j, maxi, marked, tolerance); // polyline v[j] to v[maxi]
    CanvasManager.simplifyDP(points, maxi, k, marked, tolerance); // polyline v[maxi] to v[k]
  }
  // else the approximation is OK, so ignore intermediate vertexes
};

CanvasManager.reducePoints = function (_coords, _first, _last, _tolerance1, _tolerance2) {
  var sourcePoints = _coords.slice(_first, _last + 1);
  if (sourcePoints.length < 2) {
    return sourcePoints;
  }

  // STAGE 1 - Vertex Reduction within tolerance of prior vertex cluster
  var intermediatePoints = [];
  if (_tolerance1 !== 0) {
    intermediatePoints.push(sourcePoints[0]);
    var last = 0;
    for (var i = 1; i < sourcePoints.length; i++) {
      var n = CanvasManager.vectorLengthSquared({
        x: sourcePoints[i].x - sourcePoints[last].x,
        y: sourcePoints[i].y - sourcePoints[last].y,
      });
      if (n >= _tolerance1) {
        intermediatePoints.push(sourcePoints[i]);
        last = i;
      }
    }
    if (last < sourcePoints.length - 1) {
      intermediatePoints.push(sourcePoints[sourcePoints.length - 1]);
    }
    if (_tolerance2 === 0) {
      return intermediatePoints;
    }
  } else {
    intermediatePoints = sourcePoints;
  }

  // STAGE 2 - Douglas-Peucker polyline reduction
  if (_tolerance2 !== 0) {
    var marked = Array(intermediatePoints.length).fill(false);
    marked[0] = marked[intermediatePoints.length - 1] = true;
    CanvasManager.simplifyDP(intermediatePoints, 0, intermediatePoints.length - 1, marked, _tolerance2);
    var finalPoints = [];
    for (var i = 0; i < intermediatePoints.length; i++) {
      if (marked[i]) {
        finalPoints.push(intermediatePoints[i]);
      }
    }
    return finalPoints;
  }
  return sourcePoints;
};

CanvasManager.prototype.drawLines = function (_coords, _first, _last, _isArrow, _strokeStyle, isSelfVideo, config, thickness, isLocalTelestration, isVideoTeleOnImage) {
  
  this.context.strokeStyle = (_strokeStyle[0] == '#' ? _strokeStyle : argbToRGB(_strokeStyle));
  this.context.lineWidth = thickness * this.canvas.width / CANVAS_LINE_WIDTH_FACTOR;
  
  // Implement smoothing
    var smoothed = CanvasManager.reducePoints(_coords, _first, _last, 40, 0);
    smoothed = CanvasManager.reducePoints(smoothed, 0, smoothed.length - 1, 20, 0);
    var startPointX = 0, startPointY = 0, endPointX = 0, endPointY = 0; 
    this.context.beginPath();
    
    const scaledCoords = this.calculateScale(isSelfVideo, smoothed, isLocalTelestration, config, isVideoTeleOnImage);
    startPointX = scaledCoords.startPointX;
    startPointY = scaledCoords.startPointY;
    endPointX = scaledCoords.endPointX;
    endPointY = scaledCoords.endPointY
    
    console.debug(`CM::drawLines() received startPoint (${smoothed[0].x},${smoothed[0].y})
        transformed (${startPointX},${startPointY}) :: received endPoint (${smoothed[1].x},${smoothed[1].y})
        transformed (${endPointX},${endPointY})`);
    
    this.context.moveTo(startPointX, startPointY);
    this.context.lineTo(endPointX, endPointY);
    this.context.stroke();

    // For arrow
    if (_isArrow) {
      var start = { 
        x: startPointX, 
        y: startPointY 
      };
      var end = {
        x: endPointX,
        y: endPointY,
      };
      
      // ensure we don't have the same point or we'll get a divide by 0
      if (end.x === start.x && end.y === start.y) {
        // change by one pixel
        end.x = start.x + 1;
      }
      
      // dx,dy = arrow line vector
      var dx = end.x - start.x;
      var dy = end.y - start.y;

      // normalize
      var length = Math.sqrt(dx * dx + dy * dy);
      var unitDx = dx / length;
      var unitDy = dy / length;

      // increase this to get a larger arrow head
      var xdiff = Math.abs(end.x - start.x);
      var ydiff = Math.abs(end.y - start.y);

      var arrowHeadScale = this.canvas.height / 1080;
      var arrowHeadBoxSize = CANVAS_ARRLOWLINE_HEAD_BOX_SIZE * arrowHeadScale;
      var resizeLimit = arrowHeadBoxSize * 1.75;
      if (xdiff < resizeLimit && ydiff < resizeLimit) {
        // make sure the tip length isn't abnormally long
        arrowHeadBoxSize = Math.max((Math.max(xdiff, ydiff) / resizeLimit) * arrowHeadBoxSize, 5);
      }

      var tipA = {
        x: end.x - unitDx * arrowHeadBoxSize - unitDy * arrowHeadBoxSize,
        y: end.y - unitDy * arrowHeadBoxSize + unitDx * arrowHeadBoxSize,
      };
      var tipB = {
        x: end.x - unitDx * arrowHeadBoxSize + unitDy * arrowHeadBoxSize,
        y: end.y - unitDy * arrowHeadBoxSize - unitDx * arrowHeadBoxSize,
      };

      this.context.beginPath();
      this.context.moveTo(tipA.x, tipA.y);
      this.context.lineTo(end.x, end.y);
      this.context.lineTo(tipB.x, tipB.y);
      this.context.stroke();
    }
};


CanvasManager.prototype.drawFreeHandTelestration = function (_coords, _first, _last, _isArrow, _strokeStyle,
  isSelfVideo, isStarting, isMoving, isEnd, config, thickness, isLocalTelestration, isVideoTeleOnImage, isFhRedraw) {
  this.context.strokeStyle = (_strokeStyle && _strokeStyle[0] == '#' ? _strokeStyle : argbToRGB(_strokeStyle));
  this.context.lineWidth = thickness * this.canvas.width / CANVAS_LINE_WIDTH_FACTOR;
  // Implement smoothing
  var smoothed = CanvasManager.reducePoints(_coords, _first, _last, 40, 0);
  smoothed = CanvasManager.reducePoints(smoothed, 0, smoothed.length - 1, 20, 0);
  let scaledCoords = {};
  let scaleX = 1, scaleY = 1, startPointX = 0, startPointY = 0, endPointX = 0, endPointY = 0;

  scaledCoords = this.calculateScale(isSelfVideo, smoothed, isLocalTelestration, config, isVideoTeleOnImage);
  scaleX = scaledCoords.scaleX;
  scaleY = scaledCoords.scaleY;

  const lastCoordAt = smoothed.length - 1;
  smoothed.forEach((coord, index) => {
    startPointX = coord.x * scaleX;
    startPointY = coord.y * scaleY;
    if (!isFhRedraw) {
      if (isStarting) {
        if (index === 0) {
          endPointX = smoothed[1]?.x * scaleX;
          endPointY = smoothed[1]?.y * scaleY;
          this.context.beginPath();
          this.context.moveTo(startPointX, startPointY);
          this.context.lineTo(endPointX, endPointY);
        }
      }
      if ((isStarting && index > 0) || (isMoving || isEnd)) {
        this.context.lineTo(startPointX, startPointY);
        if (index !== 0) {
          this.context.stroke();
        }
      }
      if ((index === lastCoordAt) && isEnd) {
        this.context.closePath();
      }
    } else {
      if (index === 0) {
        endPointX = smoothed[1].x * scaleX;
        endPointY = smoothed[1].y * scaleY;
        this.context.beginPath();
        this.context.moveTo(startPointX, startPointY);
        this.context.lineTo(endPointX, endPointY);
      }
      if (index > 0) {
        this.context.lineTo(startPointX, startPointY);
        this.context.stroke();
      }
      if (index === lastCoordAt) {
        this.context.closePath();
      }
    }
  });
if (_coords?.length === 0 || smoothed?.length === 0) {
  this.context.closePath();
}
};
  
CanvasManager.prototype.drawRectangle = function (_coords, _first, _last, _strokeStyle, isSelfVideo, config,thickness, isLocalTelestration,isVideoTeleOnImage) {
  this.context.strokeStyle = _strokeStyle;
  this.context.lineWidth = thickness * this.canvas.width / CANVAS_LINE_WIDTH_FACTOR;
  this.context.strokeStyle =  (_strokeStyle[0] == '#' ? _strokeStyle : argbToRGB(_strokeStyle));
    

  // Implement smoothing
  var smoothed = CanvasManager.reducePoints(_coords, _first, _last, 40, 0);
  smoothed = CanvasManager.reducePoints(smoothed, 0, smoothed.length - 1, 20, 0);
  var startPointX = 0, startPointY = 0, endPointX = 0, endPointY = 0; 


  this.context.beginPath();
  
  const scaledCoords = this.calculateScale(isSelfVideo, smoothed, isLocalTelestration,config,isVideoTeleOnImage);
  startPointX = scaledCoords.startPointX;
  startPointY = scaledCoords.startPointY;
  endPointX = scaledCoords.endPointX;
  endPointY = scaledCoords.endPointY

  console.debug(`CM::drawRectangle() received startPoint (${smoothed[0].x},${smoothed[0].y})
      transformed (${startPointX},${startPointY}) :: received endPoint (${smoothed[1].x},${smoothed[1].y})
      transformed (${endPointX},${endPointY})`);
    
    
  var x = startPointX;
  var y = startPointY;
  var w = endPointX - startPointX;
  var h =  endPointY - startPointY;
  this.context.rect(x, y, w, h);
  this.context.stroke();
};

CanvasManager.prototype.drawEllipse = function (_coords, _first, _last, _strokeStyle, isSelfVideo, config, thickness, isLocalTelestration,isVideoTeleOnImage) {
  this.context.strokeStyle =  (_strokeStyle[0] == '#' ? _strokeStyle : argbToRGB(_strokeStyle));
  this.context.lineWidth = thickness * this.canvas.width / CANVAS_LINE_WIDTH_FACTOR;
  // Implement smoothing
  var smoothed = CanvasManager.reducePoints(_coords, _first, _last, 40, 0);
  smoothed = CanvasManager.reducePoints(smoothed, 0, smoothed.length - 1, 20, 0);
  var startPointX = 0, startPointY = 0, endPointX = 0, endPointY = 0; 
  this.context.beginPath();
  
  const scaledCoords = this.calculateScale(isSelfVideo, smoothed, isLocalTelestration, config,isVideoTeleOnImage);
  startPointX = scaledCoords.startPointX;
  startPointY = scaledCoords.startPointY;
  endPointX = scaledCoords.endPointX;
  endPointY = scaledCoords.endPointY

  
  console.debug(`CM::drawEllipse() received startPoint (${smoothed[0].x},${smoothed[0].y})
      transformed (${startPointX},${startPointY}) :: received endPoint (${smoothed[1].x},${smoothed[1].y})
      transformed (${endPointX},${endPointY})`);
  
  
  var x = startPointX;
  var y = startPointY;
  var w = endPointX - startPointX;
  var h = endPointY - startPointY;

  var centerX = x + w / 2;
  var centerY = y + h / 2;

  this.context.beginPath();

  this.context.moveTo(centerX, centerY - h / 2);

  this.context.bezierCurveTo(
    centerX + (w * 2) / 3,
    centerY - h / 2,
    centerX + (w * 2) / 3,
    centerY + h / 2,
    centerX,
    centerY + h / 2,
  );

  this.context.bezierCurveTo(
    centerX - (w * 2) / 3,
    centerY + h / 2,
    centerX - (w * 2) / 3,
    centerY - h / 2,
    centerX,
    centerY - h / 2,
  );
  this.context.stroke();
};

CanvasManager.prototype.drawText = function (_textObj, _coords, _strokeStyle, isSelfVideo, config, thickness, isLocalTelestration,isVideoTeleOnImage) {
  
  let videoElement =  null;
  var smoothed = _coords;
  var startPointX = 0, startPointY = 0, endPointX = 0, endPointY = 0, scaleX=1, scaleY=1, offsetX=0, offsetY=0; 
  let scaledCoords = {};
  this.context.beginPath();
  
  scaledCoords = this.calculateScale(isSelfVideo, smoothed, isLocalTelestration,config,isVideoTeleOnImage,true);
  startPointX = scaledCoords.startPointX;
  startPointY = scaledCoords.startPointY;
  endPointX = scaledCoords.endPointX;
  endPointY = scaledCoords.endPointY
  scaleX = scaledCoords.scaleX;
  scaleY = scaledCoords.scaleY;
  offsetX = scaledCoords.offSetX;
  offsetY = scaledCoords.offSetY;
    
  console.debug(`CM::drawText() received startPoint (${smoothed[0].x},${smoothed[0].y})
        transformed (${startPointX},${startPointY}) :: received endPoint (${smoothed[1].x},${smoothed[1].y})
        transformed (${endPointX},${endPointY})`);
  var x = startPointX;
  var y = startPointY;
  var fontSize = this.calculateFontSize(this.canvas);
  this.context.fillStyle = _strokeStyle[0] === '#' ? _strokeStyle : argbToRGB(_strokeStyle);
  const calculatedWidth = Math.floor(this.canvas.width -
    (startPointX - offsetX));
  var multiLineText = _textObj.text.split('\n');
  this.context.font = ` ${fontSize}px sans-serif`;
  this.context.textBaseline = 'top';
  let slicedArray = [];

  // Get single char width for calculated font size.
  const singleCharWidth = this.getSingleCharWidth(_textObj.text[0], fontSize);

  if (multiLineText.length !== 1) {
    // Get sliced lines for multiline text.
    multiLineText.forEach((textLine) => {
      const slicedLines = this.getSliceOfLongWord(textLine, this.getMaxWidthForText(startPointX , singleCharWidth));
      if (!isEmpty(slicedLines)) {
        slicedLines.forEach((line) => {
          slicedArray.push(line);
        });
      }
    });
  } else {
    // Get sliced lines for a single line.
    slicedArray = this.getSliceOfLongWord(_textObj.text, this.getMaxWidthForText(startPointX,singleCharWidth));
  }
 
  multiLineText = slicedArray;
  if(!isEmpty(multiLineText)) {
    multiLineText.forEach((textLine, index) => {
      const multiLineY = y + (index * fontSize);
      this.context.fillText(textLine, x, multiLineY, calculatedWidth);
    });
  }
 };
  
  CanvasManager.prototype.getSingleCharWidth = (text, fontSize) => {
    const singleCharelt= document.createElement('span');
    singleCharelt.textContent = text[0];
    singleCharelt.innerHTML = text[0];
    singleCharelt.id = 'text-tele-len';
    singleCharelt.style.fontSize = fontSize + 'px';
    document.body.appendChild(singleCharelt);
    const singleCharWidth = singleCharelt.clientWidth;
    singleCharelt.remove();
    return singleCharWidth;
  }

  CanvasManager.prototype.getMaxWidthForText = (startPointX, singleCharWidth) => {
    let sliceByLen = Math.floor(singleCharWidth);
    const availableWidthForText = Math.floor((this.canvas.width - singleCharWidth) - startPointX);
    const maxCharAccommodate = Math.floor(availableWidthForText / sliceByLen);
    return maxCharAccommodate;
  }

  CanvasManager.prototype.getSliceOfLongWord = (textLine, maxCharAccommodate) => {
    let slicedWords = [];
      try {
        const regExForSlice = `.{1,${maxCharAccommodate}}`;
        const regEX = new RegExp(regExForSlice, 'g');
        if (!isEmpty(textLine)) {
          slicedWords = textLine.match(regEX);
        }
        return slicedWords;
      } catch (ex) {
        console.warn(`Error while breaking long word for text telestration`);
      }
  }
}

